import { azureFetcher } from "./fetcher";
import API_ENDPOINT from "./endpoints";

export async function FetchMenu() {
    const response = await azureFetcher.get(API_ENDPOINT.GET_USER_ROLE);
    return response.data;
}
